import { API_URL } from "@/constants/envVariables";

import { getSdpTenantName } from "@/helpers/getSdpTenantName";

export type AuthConfigResponse = {
  logout_url: string;
  issuer: string;
};

export const getAuthConfig = async (): Promise<AuthConfigResponse | null> => {
  try {
    const response = await fetch(`${API_URL}/auth/config`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "SDP-Tenant-Name": getSdpTenantName(),
      },
    });

    if (response.status === 404) {
      return null;
    }

    if (!response.ok) {
      return null;
    }

    return await response.json();
  } catch {
    return null;
  }
};
